import type {
  CustomInterrogationListItem,
  PartInterrogationFile,
} from '@frontend/api';

import type { LatentInterrogationSelection } from '../data/types';

/** Saved rows first, then unsaved defaults. */
const inPreferenceOrder = (
  results: CustomInterrogationListItem[],
): CustomInterrogationListItem[] => [
  ...results.filter((result) => result.id != null),
  ...results.filter((result) => result.id == null),
];

/** First row that has already been run. */
export const pickDefault = (
  results: CustomInterrogationListItem[],
): CustomInterrogationListItem | null =>
  inPreferenceOrder(results).find((result) => result.interrogationFileId) ??
  null;

/**
 * First match after a refetch. documentHash is not unique: two saved rows can
 * share one, and a finished run regenerates interrogationFileId, so the hash
 * is what the previous selection can be matched on.
 */
export const findByDocumentHash = (
  results: CustomInterrogationListItem[],
  documentHash: string,
): CustomInterrogationListItem | null =>
  inPreferenceOrder(results).find(
    (result) => result.documentHash === documentHash,
  ) ?? null;

export const findByInterrogationFileId = (
  results: CustomInterrogationListItem[],
  interrogationFileId: number,
): CustomInterrogationListItem | null =>
  inPreferenceOrder(results).find(
    (result) => result.interrogationFileId === interrogationFileId,
  ) ?? null;

/** Annotation part-interrogation file with no row in the custom list. */
export const toLatentSelection = ({
  id,
  documentHash,
  task,
}: PartInterrogationFile): LatentInterrogationSelection => ({
  task,
  documentHash,
  interrogationFileId: id,
  name: task,
});
